import s from './BubbleLoadingAnimation.module.css';

function BubbleLoadingAnimation() {
  return <div className={s.bubbleLoader}></div>;
}

export default BubbleLoadingAnimation;
